import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/public/aiConversation/<id>/chatMessage`;

export const usePublicAIConversationChatMessageQuery = ({
	id,
	enabled,
	initialData,
	staleTime,
}: {
	id: string;
	enabled?: boolean;
	initialData?: Api.AIChatMessage[];
	staleTime?: number;
}) => {
	return useQuery({
		queryFn: async () => {
			const response = await fetch(`${BASE_URL}/public/aiConversation/${id}/chatMessage`);
			const data: Api.IOperationResult<Api.AIChatMessage[]> = await response.json();
			if (!data.success) {
				throw new Error(data.systemMessage);
			}
			return data.value ?? [];
		},
		queryKey: [BASE_QUERY_KEY, id],
		enabled,
		initialData,
		staleTime,
	});
};

export function getPublicConversationChatMessageQueryKey({ id }: { id: string }): any[] {
	return [BASE_QUERY_KEY, id];
}
